import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Paper,
  Stack,
  Tooltip
  // Theme
} from "@mui/material";
import { CREATE_PROJECT_STEPS } from "../../constants";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { FileUploadStatus } from "../CreateProjectFlow/components";
import useCreateProject from "../../hooks/useCreateProject";

interface CreateProjectLayoutProps {
  children: React.ReactNode;
}

export const CreateProjectLayout = ({
  children
}: CreateProjectLayoutProps): React.ReactNode => {
  const {
    backStep,
    currentStep,
    handleCurrentStep,
    handleBack,
    isNextDisabled,
    isLoading,
    nextDisabledReason
  } = useCreateProject();

  const showStartDubbingButton =
    currentStep === CREATE_PROJECT_STEPS.FINISH.int ||
    currentStep === CREATE_PROJECT_STEPS.SELECT_LANGUAGE.int;

  return (
    <Box
      display={"flex"}
      sx={{
        flexDirection: "column",
        height: "100vh",
        overflow: "auto",
        maxHeight: "100%"
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          py: 3,
          px: 4,
          width: "100%",
          overflow: "auto"
        }}
      >
        <Container
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
            minHeight: "100%",
            width: "100%",
            maxWidth: 960,
            mx: "auto"
          }}
          maxWidth={false}
          id="create-project-wrapper"
          disableGutters
        >
          {children}
        </Container>
      </Box>
      {CREATE_PROJECT_STEPS["DONE"].int === currentStep ? null : (
        <Box
          sx={{
            py: 1,
            px: 4,
            width: "100%",
            overflow: "auto",
            minHeight: 80,
            display: "flex",
            alignItems: "center"
          }}
          component={Paper}
          elevation={0}
        >
          <Container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              boxSizing: "border-box",
              mx: "auto",
              maxWidth: 960
            }}
            maxWidth={false}
            disableGutters
          >
            <FileUploadStatus />

            <div
              style={{
                alignSelf: "center"
              }}
            >
              <Stack direction={"row"} justifyContent={"center"}>
                {backStep ? (
                  <Button
                    id="btn-create-project-back"
                    variant="contained"
                    color="secondary"
                    onClick={handleBack}
                    startIcon={<ChevronLeft />}
                    sx={{
                      mr: 3
                    }}
                    size="large"
                  >
                    {backStep.enum === CREATE_PROJECT_STEPS.UPLOAD_FILES.enum
                      ? "Upload Files"
                      : "Back"}
                  </Button>
                ) : null}
                <Tooltip placement="top" title={nextDisabledReason}>
                  <span>
                    <Button
                      id="btn-create-project-next"
                      variant="contained"
                      size="large"
                      onClick={() => {
                        handleCurrentStep();
                      }}
                      startIcon={
                        isLoading ? (
                          <CircularProgress
                            size={16}
                            thickness={4}
                            color="secondary"
                          />
                        ) : null
                      }
                      endIcon={<ChevronRight />}
                      disabled={isNextDisabled}
                      color={showStartDubbingButton ? "brand" : "primary"}
                    >
                      {showStartDubbingButton ? "Start Dubbing" : "Next"}
                    </Button>
                  </span>
                </Tooltip>
              </Stack>
            </div>
          </Container>
        </Box>
      )}
    </Box>
  );
};
